import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import onClickOutside from 'react-onclickoutside';
import cx from 'classnames';
import { translate } from 'react-i18next';
import moment from 'moment-timezone';
import 'moment-duration-format';
import Slider from './Slider';
import { FilterRanges } from '../../../utils/filterRanges';

@translate(['rides-sidebar'], { wait: true })
@onClickOutside
class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false,
    };
  }

  toggleFilters = () => {
    this.setState({
      opened: !this.state.opened,
      distance: this.props.distance,
      duration: this.props.duration,
      range: this.props.range,
    });
  };

  getRangeLabel = () => {
    const [m1, m2] = this.state.range;
    return `${m1.format('DD MMMM')} - ${m2.format('DD MMMM YYYY')}`;
  };

  handleClickOutside = () => {
    this.setState({
      opened: false,
    });
  };

  applyFilter = e => {
    const { distance, duration, range } = this.state,
      { applyFilter } = this.props;

    e.preventDefault();

    applyFilter({
      distance,
      duration,
      range,
    });

    this.setState({
      opened: false,
    });
  };

  clearFilter = e => {
    e.preventDefault();
    this.setState({
      opened: false,
    });
    this.props.clearFilter();
  };

  handleDistanceSlideStop = event => {
    this.setState({
      distance: event.target.value,
    });
  };

  handleDurationSlideStop = event => {
    this.setState({
      duration: event.target.value,
    });
  };

  handleRangeApply = (event, picker) => {
    this.setState({
      range: [moment(picker.startDate), moment(picker.endDate)],
    });
  };

  render() {
    const { distance, duration, range, t } = this.props;
    FilterRanges.setT(t)

    return (
      <div
        className={cx('aside__filter__btn__wrap', {
          openDrop: this.state.opened,
        })}
      >
        <span
          onClick={this.toggleFilters}
          className="aside__filter__btn aside__filter__btn-calendar"
        />
        {this.state.opened && (
          <div className="aside__filter__drop">
            <form className="aside__filter__set" action="#">
              <div className="sliderRangeWrapper">
                <Slider
                  max={1000}
                  min={0}
                  title={t('rides-sidebar:distance')}
                  slideStop={this.handleDistanceSlideStop}
                  getRange={FilterRanges.getDistanceRange}
                  range={distance}
                />
              </div>
              <div className="sliderRangeWrapper">
                <Slider
                  className="sliderRange sliderRange__date"
                  max={720}
                  min={0}
                  title={t('rides-sidebar:duration')}
                  slideStop={this.handleDurationSlideStop}
                  getRange={FilterRanges.getDurationRange}
                  range={duration}
                />
              </div>
              <div className="reportrangeWrap">
                <DateRangePicker
                  autoApply
                  onApply={this.handleRangeApply}
                  parentEl=".reportrangeWrap"
                  startDate={range[0]}
                  endDate={range[1]}
                  maxDate={moment()}
                  minDate={moment('01/01/2012', 'DD/MM/YYYY')}
                  alwaysShowCalendars={true} // eslint-disable-line react/jsx-boolean-value
                  showDropdowns={false}
                  showWeekNumbers={false}
                  timePicker={false}
                  showCustomRangeLabel={false}
                  format={'DD.MM.YYYY'}
                  locale={{
                    format: 'DD.MM.YYYY',
                    customRangeLabel: 'Custom Range',
                    firstDay: 1,
                  }}
                  dateLimit={{ days: 90 }}
                >
                  <div>
                    <div className="title">{t('rides-sidebar:period')}</div>
                    <div className="reportrange">
                      <span>{this.getRangeLabel()}</span>{' '}
                      <b className="caret" />
                    </div>
                  </div>
                </DateRangePicker>
              </div>
              <div className="aside__filter__drop__btnRow">
                <button
                  onClick={this.clearFilter}
                  type="button"
                  className="aside__filter__drop__btnRow__reset"
                >
                  {t('rides-sidebar:reset')}
                </button>
                <button
                  onClick={this.applyFilter}
                  type="submit"
                  className="aside__filter__drop__btnRow__apply"
                >
                  {t('rides-sidebar:submit')}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    );
  }
}

Filters.propTypes = {
  distance: PropTypes.array,
  duration: PropTypes.array,
  range: PropTypes.array,
  clearFilter: PropTypes.func,
  applyFilter: PropTypes.func,
};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/Filters.js